const StationType = [
	"DODOX", 
	"WIDOX", 
	"COXO",
]

export { StationType }